/* eslint-disable import/no-named-as-default-member */
import create from 'zustand';

interface IOrderbookModal {
  visible: boolean;
  symbol?: string;
  price?: number;
  orderType?: string;
  orders: any[];
  showModal?: (any) => void;
  resetModal: () => void;
}

const initialState = {
  visible: false,
  symbol: null,
  price: null,
  orderType: null,
  orders: [],
};

const orderbookModalStore = create<IOrderbookModal>((set) => ({
  ...initialState,
  showModal: (payload) => {
    set({ visible: true, ...payload });
  },
  resetModal: () => {
    set(initialState);
  },
}));

export default orderbookModalStore;
